import { v4 as uuid } from 'uuid'

export default function layouts (platform, hostname, factory) {
  const pushStoreAction = (action) => {
    platform.store.update(store => {
      store.editor.actions.push(action)

      return store
    })
  }

  const layouts = {
    ...factory.createRoute(platform, hostname, '/api/cms/layouts'),
    createLayout (data, types) {
      if (!data.blockId) {
        return
      }

      const renderData = data.renderData

      const blockId = data.blockId
      const nextBlockId = data.nextBlockId
      const newNodeId = data.newNodeId || uuid()
      const newBlockId = data.newBlockId || uuid()
      const newGroupId = data.newGroupId || uuid()

      platform.store.update(store => {
        const render = renderData || store?.render

        render.blocks[blockId] = {
          ...render.blocks[blockId],
          nodes: render.blocks[blockId]?.nodes || [],
        }

        render.blocks[blockId].nodes.push({
          id: newNodeId,
          blockId,
          type: types.LAYOUT,
          nextBlockId,
          groupId: newGroupId,
          block: { id: blockId, nodes: [] },
        })

        return store
      })

      pushStoreAction({
        name: 'NODE_CREATE',
        meta: {
          blockId,
          nodeId: newNodeId,
          type: types.LAYOUT,
          nextBlockId,
          groupId: newGroupId,
        },
      })

      if (!nextBlockId) {
        platform.store.update(store => {
          const render = renderData || store?.render

          render.blocks[newBlockId] = {
            id: newBlockId,
            nodes: [
              { id: newNodeId, blockId: newBlockId },
            ],
          }

          return store
        })

        pushStoreAction({
          name: 'LAYOUT_BLOCK_CREATE',
          meta: {
            nodeId: newNodeId,
            blockId: newBlockId,
          },
        })

        const newRowNodeId = data.newRowNodeId || uuid()
        const newRowBlockId = data.newRowBlockId || uuid()

        platform.store.update(store => {
          const render = renderData || store?.render

          store.editor.newLayoutBlockId = newBlockId
          render.blocks[newBlockId] = {
            ...render.blocks[newBlockId],
            nodes: [{
              id: newRowNodeId,
              blockId: newBlockId,
              type: types.ROW,
            }],
          }

          return store
        })

        pushStoreAction({
          name: 'NODE_CREATE',
          meta: {
            blockId: newBlockId,
            nodeId: newRowNodeId,
            type: types.ROW,
          },
        })

        platform.store.update(store => {
          const render = renderData || store?.render

          render.blocks[newRowBlockId] = {
            id: newRowBlockId,
            nodes: [
              {
                id: newRowNodeId,
                blockId: newRowBlockId,
              },
            ],
          }

          return store
        })

        pushStoreAction({
          name: 'LAYOUT_BLOCK_CREATE',
          meta: {
            nodeId: newRowNodeId,
            blockId: newRowBlockId,
          },
        })

        const newColNodeId = data.newColNodeId || uuid()
        const newColBlockId = data.newColBlockId || uuid()

        platform.store.update(store => {
          const render = renderData || store?.render

          render.blocks[newRowBlockId].nodes.push({
            id: newColNodeId,
            type: types.COL_UNIQUE,
            block: { id: blockId, nodes: [] },
          })

          return store
        })

        pushStoreAction({
          name: 'NODE_CREATE',
          meta: {
            blockId: newRowBlockId,
            nodeId: newColNodeId,
            type: types.COL_UNIQUE,
          },
        })

        platform.store.update(store => {
          const render = renderData || store?.render

          render.blocks[newColBlockId] = {
            id: newColBlockId,
            nodes: [],
          }

          return store
        })

        pushStoreAction({
          name: 'BLOCK_CREATE',
          meta: {
            blockId: newColBlockId,
          },
        })

        platform.store.update(store => {
          const render = renderData || store?.render

          render.links[newColNodeId] = newColBlockId

          return store
        })

        pushStoreAction({
          name: 'LINK_SET',
          meta: {
            nodeId: newColNodeId,
            blockId: newColBlockId,
          },
        })
      }
    },
    async findAllNodeData (layoutId) {
      const res = await platform.fetch(`/api/cms/layouts/${layoutId}/node-data`)

      return await res.json()
    },
  }

  return layouts
}
